if (!customElements.get('wls-about-product')) {
    class WLSAboutProduct extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                visible: 'is-visible',
                active: 'is-active',
                trigger: 'js-wls-about-trigger',
                panel: 'js-wls-about-panel',
                navigation: 'js-wls-splide-navigation',
                dots: 'js-wls-splide-navigation-dots',
                dot: 'wls-splide-navigation__dot'
            };

            this.triggers = [...this.querySelectorAll(`.${this.classes.trigger}`)];
            this.panels = [...this.querySelectorAll(`.${this.classes.panel}`)];

            this.navigation = this.querySelector(`.${this.classes.navigation}`);
            this.dotsWrapper = this.querySelector(`.${this.classes.dots}`);
            this.prevArrow = this.querySelector('.js-wls-splide-navigation-arrow-prev');
            this.nextArrow = this.querySelector('.js-wls-splide-navigation-arrow-next');

            this.activeIndex = 0;
        }

        connectedCallback() {
            if (!this.triggers.length || !this.panels.length) return;

            if (this.triggers.length <= 1) {
                this.navigation.style.display = 'none';
            }

            this.createDots();
            this.bindEvents();
            this.updateUI();
        }

        bindEvents() {
            this.triggers.forEach((trigger, index) => {
                trigger.addEventListener('click', () => {
                    this.goTo(index);
                });
            });

            this.prevArrow?.addEventListener('click', () => {
                this.goTo(this.activeIndex - 1);
            });

            this.nextArrow?.addEventListener('click', () => {
                this.goTo(this.activeIndex + 1);
            });
        }

        createDots() {
            if (!this.dotsWrapper || this.triggers.length <= 1) return;

            this.dotsWrapper.innerHTML = '';

            this.triggers.forEach((_, index) => {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = this.classes.dot;

                dot.addEventListener('click', () => {
                    this.goTo(index);
                });

                this.dotsWrapper.appendChild(dot);
            });

            this.dots = [...this.dotsWrapper.children];
        }

        goTo(index) {
            if (index < 0) index = this.triggers.length - 1;
            if (index >= this.triggers.length) index = 0;

            this.activeIndex = index;
            this.updateUI();
        }

        updateUI() {
            this.triggers.forEach((trigger, i) => {
                trigger.classList.toggle(this.classes.active, i === this.activeIndex);
            });

            this.panels.forEach((panel, i) => {
                panel.classList.toggle(this.classes.visible, i === this.activeIndex);
            });

            this.dots?.forEach((dot, i) => {
                dot.classList.toggle(this.classes.active, i === this.activeIndex);
            });

        }

    }

    customElements.define('wls-about-product', WLSAboutProduct);
}
